var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117 363 c-4 -3 -7 -61 -7 -127 0 -155 1 -156 135 -156 l95 0 0 45 c0 25 -4 45 -10 45 -6 0 -10 28 -10 63 0 60 -2 65 -38 100 -35 34 -42 37 -98 37 -33 0 -64 -3 -67 -7z m123 -38 c4 -25 10 -30 38 -33 l32 -3 0 -60 0 -59 -85 0 -85 0 0 -30 c0 -16 -4 -30 -10 -30 -11 0 -14 232 -3 244 4 4 30 6 58 4 47 -3 50 -5 55 -33z m35 -5 c18 -19 17 -20 -3 -20 -15 0 -22 6 -22 20 0 11 2 20 3 20 2 0 12 -9 22 -20z m55 -195 l0 -35 -90 0 -90 0 0 35 0 35 90 0 90 0 0 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178 273 c23 -2 59 -2 80 0 20 2 1 4 -43 4 -44 0 -61 -2 -37 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178 243 c23 -2 59 -2 80 0 20 2 1 4 -43 4 -44 0 -61 -2 -37 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178 213 c23 -2 59 -2 80 0 20 2 1 4 -43 4 -44 0 -61 -2 -37 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158 183 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230 125 c7 -9 15 -13 17 -11 7 7 -7 26 -19 26 -6 0 -6 -6 2 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260 120 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.7f0e4c1aa03ec09b2a4f02b836e539f6.svg";
export { ForwardRef as ReactComponent };